import { TenantType } from 'types/common';
import { EntityType } from 'types/customer';
import { IS_DEV, IS_STAGING, IS_UAT } from '../constants';
import { getQueryValue } from '../storage';

export function getBaggage(tenantId: TenantType, entityId?: EntityType) {
    return `tenantId=${tenantId}${entityId ? `,entityId=${entityId}` : ''}`;
}

export const SUPPORT_BAGGAGE_HEADER = IS_DEV || IS_STAGING || IS_UAT || getQueryValue('allowBaggage') === '1';
